import { createContext, useContext, useEffect, useState } from 'react'

import {
  isSignInWithEmailLink as _isSignInWithEmailLink,
  sendSignInLinkToEmail as _sendSignInLinkToEmail,
  signInWithEmailLink as _signInWithEmailLink,
  signOut as _signOut,
  onAuthStateChanged,
} from 'firebase/auth'

import { auth } from 'lib/firebase'
import { httpsCallable } from 'lib/functions'

const KEY_SIGNIN_EMAIL = 'SIGNIN_EMAIL'
const storage = window.localStorage
const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [initialized, setInitialized] = useState(false)
  const [user, setUser] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    return onAuthStateChanged(auth, async user => {
      console.log('user', user)
      if (user) {
        const { claims } = await user.getIdTokenResult(true)
        console.log('admin', claims.admin)
        if (claims.admin) {
          setIsAdmin(true)
        }
        setUser(user)
        setInitialized(true)
      } else {
        setUser(null)
        setInitialized(true)
      }
    })
  }, [])

  return (
    <AuthContext.Provider
      value={{
        initialized,
        user,
        setUser,
        isAdmin,
      }}
      children={children}
    />
  )
}

export default function useAuth() {
  return useContext(AuthContext)
}

export const sendSignInLink = email => {
  return httpsCallable('callable-user-login')({
    email,
    url: `${window.location.origin}/finishLogin`,
  }).then(() => storage.setItem(KEY_SIGNIN_EMAIL, email))
}

export const sendSignInLinkToEmail = email => {
  const actionCodeSettings = {
    url: `${window.location.origin}/finishSignUp`,
    handleCodeInApp: true,
  }
  return _sendSignInLinkToEmail(auth, email, actionCodeSettings).then(() =>
    storage.setItem(KEY_SIGNIN_EMAIL, email)
  )
}

export const signOut = () => {
  return _signOut(auth)
}

export const isSignInWithEmailLink = url => {
  return _isSignInWithEmailLink(auth, url)
}

export const signInWithEmailLink = email => {
  return _signInWithEmailLink(auth, email, window.location.href).then(() =>
    localStorage.removeItem(KEY_SIGNIN_EMAIL)
  )
}

export const getSignUpEmail = () => {
  return storage.getItem(KEY_SIGNIN_EMAIL)
}
